import CaptchaForm from './CaptchaForm';


export default CaptchaForm;
